if (!customElements.get('ys-policy-page')) {
  customElements.define('ys-policy-page', class extends HTMLElement {
    connectedCallback() {
      this.navigation?.disconnect();
      const nav = this.querySelector('[data-policy-nav]');
      const links = this.querySelector('[data-policy-links]');
      const headings = [...this.querySelectorAll('[data-policy-body] [data-policy-heading]')];
      if (!nav || !links || !headings.length || !window.YesoulPolicyNavigation) return;
      const PolicyNavigation = class extends window.YesoulPolicyNavigation {
        mark(id) {
          super.mark(id);
          if (matchMedia('(max-width: 999px)').matches || this.dragging || performance.now() < this.manualUntil) return;
          const active = this.anchors.find(anchor => anchor.hash === `#${id}`);
          if (!active) return;
          const outer = this.links.getBoundingClientRect();
          const inner = active.getBoundingClientRect();
          const delta = inner.top < outer.top + 4 ? inner.top - outer.top - 4
            : inner.bottom > outer.bottom - 4 ? inner.bottom - outer.bottom + 4 : 0;
          if (delta) this.links.scrollBy({top: delta, behavior: 'instant'});
        }
      };
      this.dataset.enhanced = 'true';
      this.navigation = new PolicyNavigation({root: this, nav, links, headings});
    }
    disconnectedCallback() {
      this.navigation?.disconnect();
    }
  });
}
